// frontend/packages/business-console/src/pages/AiWriterPanel.jsx
//
// The "AI Writer" tab of the Content workspace (plan 3.1.4). A shallow
// create-type toggle picks what to make - a blog post (BlogAuthor) or a
// structured service page (ServicePageAuthor) - then renders that author
// embedded. Keeps the cockpit single-surface principle: one nav entry
// (Content), one AI Writer tab, no deep nesting. New page types (more
// productized modules, per the module-library strategy) slot in as more
// toggle options here.

import React, { useState } from 'react';
import { Box, ToggleButton, ToggleButtonGroup } from '@mui/material';
import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';

import BlogAuthor from './BlogAuthor';
import ServicePageAuthor from './ServicePageAuthor';

export default function AiWriterPanel() {
  const [kind, setKind] = useState('blog');

  return (
    <Box>
      <Box sx={{ px: { xs: 2, md: 3 }, pt: 1.5, pb: 0.5 }}>
        <ToggleButtonGroup
          size="small"
          exclusive
          value={kind}
          onChange={(_e, v) => {
            if (v) setKind(v);
          }}
          aria-label="What do you want to create?"
        >
          <ToggleButton value="blog" sx={{ textTransform: 'none' }}>
            <ArticleOutlinedIcon fontSize="small" sx={{ mr: 0.75 }} />
            Blog post
          </ToggleButton>
          <ToggleButton value="service" sx={{ textTransform: 'none' }}>
            <DescriptionOutlinedIcon fontSize="small" sx={{ mr: 0.75 }} />
            Service page
          </ToggleButton>
        </ToggleButtonGroup>
      </Box>
      {kind === 'blog' ? <BlogAuthor embedded /> : <ServicePageAuthor embedded />}
    </Box>
  );
}
